import styled, { css } from 'styled-components'

import Link from '../../../../../../global/Link'

export interface ItemDisplayModeProps {
  $displayMode?: 'normal' | 'compact'
}

export const ItemTitle = styled.div`
  border: 0 solid red;
  color: ${({ theme }) => theme.colors.neutralGray.neutral600};
  display: block;
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontFamilies.gothamNarrow};
  font-weight: 500;
  font-size: 1rem;
  margin: 0 1px;
  padding: 2px 10px;
  text-decoration: none;
  width: 100%;
`

const commonItemContainerStyles = css`
  align-items: center;
  border-left: 3px solid transparent;
  display: flex;
  overflow: hidden;
  max-height: 200px;
  max-width: 100%;
  text-decoration: none;
  white-space: normal;
  text-transform: unset;
  &:hover,
  &:focus {
    border-left-color: ${({ theme }) => theme.colors.brand.red};
    outline: none !important;
    ${ItemTitle} {
      color: ${({ theme }) => theme.colors.neutralGray.neutral900};
    }
  }
`

export const ItemContainerLink = styled(Link)`
  ${commonItemContainerStyles}
`

export const ItemContainer = styled.div`
  ${commonItemContainerStyles}
`

export const ItemImageContainer = styled.div<ItemDisplayModeProps>`
  flex: 0 0 calc(100% / 3);
  max-width: ${({ $displayMode }) => ($displayMode === 'compact' ? '115px' : '180px')};
  position: relative;
  &:after {
    display: block;
    content: '';
    padding-top: 100%;
  }
`

export const ItemImage = styled.img`
  position: absolute;
  top: 0;
  display: block;
  margin: 50%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transform: translateX(-50%) translateY(-50%);
`

export const ItemDescription = styled.span<ItemDisplayModeProps>`
  display: block;
  margin-top: ${({ $displayMode }) => ($displayMode === 'compact' ? '7px' : '15px')};
  font-size: 0.8rem;
  font-weight: 400;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
